import _ from 'lodash';
import moment from "moment";
import { Cache } from "aws-amplify/utils";
import {
  APPLY_FOR_A_JOB,
  APPLY_FOR_A_JOB_UPDATE,
  FETCH_JOBITEMS,
  SET_FAVOURITE_JOB,
  SET_SELECTED_JOB,
  BLACKLIST_OCC,
  SET_BLACKLIST,
  RESET_JOBS,
  FETCH_JOB_CATEGORIES,
  FETCH_QUALIFICATIONS,
  FETCH_CERTIFICATIONS,
  FETCH_ALL_JOBS,
  FETCH_INDIVIDUAL_JOBS,
  ADD_FILTER,
  OCC_FILTER,
  JOBS_FILTER,
  LEVEL_FILTER,
  FETCH_CENTRES,
  TOGGLE_LOADING,
  SET_RESOURCES,
  SET_ONLINE_COURSES,
  SET_ACTIVE_RESOURCE,
  LOADING_RESOURCES,
  UPDATE_OCCUPATION_SKILL,
  MARK_ITEM_READ,
  UPDATE_FULL_DESCRIPTION,
  OPTIONAL_SKILL_CHECK,
  LOADED_CONTENT_DASHBOARD,
  LOADING_ONLINE_COURSES,
  UPDATE_JOB_CATEGORIES,
  UPDATE_LOAD_MORE_COUNT,
  FETCH_ALL_JOBS_COMPLETE,
  SET_APPLICATIONS_NOTIFICATION,
  TOGGLE_PROJECTS
} from "../actions/types";

export const jobReducer = (state = {}, action) => {
  switch (action.type) {
    case RESET_JOBS:
      Cache.removeItem("jobCategories");
      Cache.removeItem("jobCategoriesV2");
      Cache.removeItem("jobs_nearme");
      Cache.removeItem("jobs_nearmeV2");
      Cache.removeItem("jobs");
      Cache.removeItem("jobsV2");
      Cache.removeItem("quals");
      Cache.removeItem("qualsV2");

      return {
        occupationListFilter: [
          { name: "Preferred", value: true },
          { name: "Previous", value: true },
          { name: "Skills", value: true },
          { name: "Styles", value: true },
          { name: "Interest", value: true },
          { name: "Searched", value: true },
        ],
      };
      //return {};

    case TOGGLE_LOADING:
      return {
        ...state,
        loading : action.setToggle
      };

    case LOADING_RESOURCES: {
      return {
        ...state,
        resourceLoading: action.loading
      }
    }
    
    case LOADING_ONLINE_COURSES: {
      return {
        ...state,
        coursesLoading: action.loading
      }
    }

    case SET_APPLICATIONS_NOTIFICATION: {
      return {
        ...state,
        applicationNotification: true
      }
    } 

    case FETCH_JOB_CATEGORIES:

      var jobCategories = [];

      var {
        desired_occupations = [],
        past_occupations = [],
        skills_backpack_occupations = [],
        styles_occupations = [],
        interest_occupations = [],
        searched_occupations = []
      } = action.jobs || state.rawJobCategories;
      
    
      var quals = [];
      let occupationArr = [];

      let both = [];
      for (const idx in action.desiredExp) {
        if (action.desiredExp[idx]){
          both.push(action.preferredOccupations[idx])
        }
      }

      for (let i = 0; i < desired_occupations.length; i++){
        let item = desired_occupations[i];
        if (!item) continue;
        if (item.main_occupation){
           if (item.qualification_name) {
            quals = [...quals, ...item.qualification_name];
           }
           else{
            item.qualification_name = []
           }
        }
        
        let title = "Preferred";
        if (both.includes(item.occupation)){
          title = "Previous & Preferred";
        }

        occupationArr.push({
          ...item,
          catType: "desired",
          catTitle: title,
          occKey: "desired_occupations",
          jobsCount: 0,
        });
      }


      
      for (let i = 0;  i < past_occupations.length; i++){
        let item = past_occupations[i];
        if (!item) continue;
        if (item.main_occupation && item.qualification_name){
          quals = [...quals, ...item.qualification_name];
        }
        else{
          item.qualification_name = []
         }
        occupationArr.push({
          ...item,
          catType: "past",
          catTitle: "Previous",
          occKey: "past_occupations",
          jobsCount: 0,
        });
      }

      for (let i = 0; i < skills_backpack_occupations.length; i++){
        let item = skills_backpack_occupations[i];
        if (!item) continue;
        if (item.main_occupation && item.qualification_name){
          quals = [...quals, ...item.qualification_name];
        }
        else{
          item.qualification_name = []
         }
        occupationArr.push({
          ...item,
          catType: "skills_backpack",
          catTitle: "Skills",
          occKey: "skills_backpack_occupations",
          jobsCount: 0,
        });
      }

      for (let i = 0;  i < styles_occupations.length; i++){
        let item = styles_occupations[i];
        if (!item) continue;
        if (item.qualification_name){
          quals = [...quals, ...item.qualification_name];
        }
        else{
          item.qualification_name = []
         }
        occupationArr.push({
          ...item,
          catType: "styles",
          catTitle: "Styles",
          occKey: "styles_occupations",
          jobsCount: 0,
        });
      }


      for (let i = 0; i < interest_occupations.length; i++){
        let item = interest_occupations[i];
        if (!item) continue;
        if (item.qualification_name){
          quals = [...quals, ...item.qualification_name];
        }
        else{
          item.qualification_name = []
         }
        occupationArr.push({
          ...item,
          catType: "interest",
          catTitle: "Interest",
          occKey: "interest_occupations",
          jobsCount: 0
        });
      }


      for (let i = 0;  i < searched_occupations.length; i++){
        let item = searched_occupations[i];
        if (item.qualification_name){
          quals = [...quals, ...item.qualification_name];
        }
        else{
          item.qualification_name = []
         }
        occupationArr.push({
          ...item,
          catType: "searched",
          catTitle: "Searched",
          occKey: "searched_occupations",
          jobsCount: 0,
        });
      }

      jobCategories = [
        ...occupationArr
      ];
      return {
        ...state,
        jobCategories,
        rawJobCategories: action.jobs,
        allJobCategories: jobCategories,
        qualNames: [...new Set(quals)],
      };

    case UPDATE_JOB_CATEGORIES:
      return {
        ...state,
        rawJobCategories: action.jobCategories,
      };

    case FETCH_ALL_JOBS:

      // var j = state.jobCategories || [];

      let occupationListFilter = _.cloneDeep(state.occupationListFilter);
      let idList = []
      var _allJobCategories = _.cloneDeep(state.allJobCategories) || []

      // rather doing a find each time we need to look up an occupation, create a key dict where we can just lookup the key occupationName
      let occupations = {};
      _.each(_allJobCategories, (o) => { if (!occupations[o.occupation]) occupations[o.occupation] = o; });
      Object.keys(action.jobs).forEach((key) => {
        action.jobs[key] = action.jobs[key].map((item) => { // eslint-disable-line
          item.jobId = "" + item.jobId
          if (idList.includes(item.jobId)){ // duplicate
            return false
          }
          else{
            idList.push(item.jobId)
          }
          
          const findIndex = _allJobCategories.findIndex(cat => cat.occupation === item.occupation || cat.occupation === item.parent_occupation);
          if (findIndex !== -1) {
            _allJobCategories[findIndex].jobsCount = (_allJobCategories[findIndex].jobsCount || 0) + 1;
          }
            var f =  _.cloneDeep(occupations[item.occupation]);

            // if (key === "past_occupations"){
            //    f = occupations[item.matched_occupation];
            // }
            if (!f) { 
              return false; 
            } 
            else { 
              var findCat = false
              if (key === "desired_occupations"){
                findCat = occupations[f.parent_occupation];
                item.original_occupation = item.occupation;
                item.occupation = findCat.occupation;
                item.main_occupation = true;
                
              } else {
                findCat = occupations[item.occupation];
              }

            // cache isn't being overwriten by new occupation scores...
            // so we need to ensure the values are deleted first.
            
              if(item.score_bp === undefined){
                delete item.score_bp;
              }
              else{
                delete f.score_bp;
              }
  
              if(item.score_interest === undefined){
                delete item.score_interest;
              }
              else{
                delete f.score_interest;
              }
  
              if(item.score_styles === undefined){
                delete item.score_styles;
              }
              else{
                delete f.score_styles;
              }

              if(item.missing_skills){
                delete f.missing_skills;
                delete f.similar_skills;
              }
              else{
                delete item.missing_skills;
                delete item.missing_skills;
              }

              var catType = "desired";
              var catTitle = "Preferred";

              if (key === "past_occupations") {
                catType = "past";
                catTitle = "Previous";
              }
              if (key === "skills_backpack_occupations") {
                catType = "skills_backpack";
                catTitle = "Skills";
              }
              if (key === "styles_occupations") {
                catType = "styles";
                catTitle = "Styles";
              }

              if (key === "interest_occupations") {
                catType = "interest";
                catTitle = "Interest";
              }
              if (key === "searched_occupations") {
                catType = "searched";
                catTitle = "Searched";
              }
            const lower_contract = item.job_contract.toLowerCase()
            let obj = {
              ...f,
              ...item,
              catType,
              catTitle,
              postedDate: item.postedDate ? item.postedDate.toString().length > 10 ? item.postedDate : item.postedDate * 1000 : "Unknown",
              employerName:
                item.employerName === "" || item.employerName === "not_specified"
                  ? "Employer Unknown"
                  : item.employerName,
              provider_image: item.is_apprenticeship ? "apprenticeships" : item.provider_image,
              job_contract: lower_contract.includes("full") ? "Full Time" : lower_contract.includes("part") ? "Part Time" : item.job_contract,
              ONET_interests: item.onet_interests ? item.onet_interests : f.ONET_interests,
              ONET_styles: item.onet_styles ? item.onet_styles :  f.ONET_styles,
            }
            return obj;
          }
        }).filter(Boolean);
      })


      var {
        desired_occupations = [],
        past_occupations = [],
        skills_backpack_occupations = [],
        styles_occupations = [],
        interest_occupations = [],
        searched_occupations = [],
      } = action.jobs;

      let allJobs = [
        ...desired_occupations,
        ...past_occupations,
        ...skills_backpack_occupations,
        ...styles_occupations,
        ...interest_occupations,
        ...searched_occupations
      ];

      allJobs = _.orderBy(allJobs, [({ vacancy_flag }) => vacancy_flag === true, "score_bp"], ["desc", "desc"]);
      
      for (const cat of _allJobCategories) {
        // if(cat.jobsCount && cat.jobsCount > 0){
          occupationListFilter = occupationListFilter.map((filterCat) => {
            if(filterCat.catType === cat.catType && !(filterCat.subList.find((subOcc) => subOcc.name === cat.occupation))){
              return {
                ...filterCat,
                subList: [...filterCat.subList, { name: cat.occupation, value: false }]
              };
            }
            return filterCat;
          });
        // }
      }

      return {
        ...state,
        allJobCategories: _allJobCategories,
        allJobs: allJobs,
        idList: idList,
        occupationListFilter: occupationListFilter
      };

    case FETCH_INDIVIDUAL_JOBS:

      let _occupationListFilter = _.cloneDeep(state.occupationListFilter)
      let idFilterList = _.cloneDeep(state.idList) || []
      var allJobsList = _.cloneDeep(state.allJobs) || []
      var _allJobCategories = _.cloneDeep(state.allJobCategories) || []
      const key = action.jobsKey
      let _occupations = {};
      _.each(_allJobCategories, (o) => { if (!_occupations[o.occupation]) _occupations[o.occupation] = o});
      
      let newJobsList = action.jobs[key].map((item) => {
        item.jobId = "" + item.jobId
        if (idFilterList.includes(item.jobId)){ // duplicate
          //console.log("duplicate")
          // console.log(item)
          return false
        }
        else{
          idFilterList.push(item.jobId)
        }
        const findIndex = _allJobCategories.findIndex(cat => cat.occupation === item.occupation || cat.occupation === item.parent_occupation);
        if (findIndex !== -1) {
          _allJobCategories[findIndex].jobsCount = (_allJobCategories[findIndex].jobsCount || 0) + 1;
        }
          var f = _.cloneDeep(_occupations[item.occupation]);

          // if (key === "past_occupations"){
          //     f = _occupations[item.matched_occupation];
          // }
          if (!f) { 
            // console.log("no f")
            // console.log(item)
            return false; } 
          
          else { 
            var findCat = false
            if (key === "desired_occupations"){
              findCat = _.cloneDeep(_occupations[f.parent_occupation]);
              item.original_occupation = item.occupation;
              item.occupation = findCat.occupation;
              item.main_occupation = true;
            } else {
              findCat = _.cloneDeep(_occupations[item.occupation]);
            }

          // cache isn't being overwriten by new occupation scores...
          // so we need to ensure the values are deleted first.
            if(item.score_bp === undefined){
              delete item.score_bp;
            }
            else{
              delete f.score_bp;
            }

            if(item.score_interest === undefined){
              delete item.score_interest;
            }
            else{
              delete f.score_interest;
            }

            if(item.score_styles === undefined){
              delete item.score_styles;
            }
            else{
              delete f.score_styles;
            }

            if(item.missing_skills){
              delete f.missing_skills;
              delete f.similar_skills;
            }
            else{
              delete item.missing_skills;
              delete item.missing_skills;
            }
            

            var catType = "desired";
            var catTitle = "Preferred";

            if (key === "past_occupations") {
              catType = "past";
              catTitle = "Previous";
            }
            if (key === "skills_backpack_occupations") {
              catType = "skills_backpack";
              catTitle = "Skills";
            }
            if (key === "styles_occupations") {
              catType = "styles";
              catTitle = "Styles";
            }

            if (key === "interest_occupations") {
              catType = "interest";
              catTitle = "Interest";
            }
            if (key === "searched_occupations") {
              catType = "searched";
              catTitle = "Searched";
            }

          const lower_contract = item.job_contract.toLowerCase()
          let obj = {
            ...f,
            ...item,
            catType,
            catTitle,
            postedDate: item.postedDate ? item.postedDate.toString().length > 10 ? item.postedDate : item.postedDate * 1000 : "Unknown",
            employerName:
              item.employerName === "" || item.employerName === "not_specified"
                ? "Employer Unknown"
                : item.employerName,
            job_contract: lower_contract.includes("full") ? "Full Time" : lower_contract.includes("part") ? "Part Time" : item.job_contract
          }
          
          return obj;
        }
      }).filter(Boolean);

      if(action.loadMore){
        allJobsList = allJobsList.concat(_.orderBy(newJobsList, [({ vacancy_flag }) => vacancy_flag === true, "score_bp"], ["desc", "desc"]))
      }
      else{
        allJobsList = _.orderBy(allJobsList.concat(newJobsList), [({ vacancy_flag }) => vacancy_flag === true, "score_bp"], ["desc", "desc"])
      }
      

      let newJobCategories = [];
      //convert from asso array to flat array.
      _.each(_occupations, (i) => {
        newJobCategories.push(i);
      });
      for (const cat of newJobCategories) {
        // if(cat.jobsCount && cat.jobsCount > 0){
          _occupationListFilter = _occupationListFilter.map((filterCat) => {
            if(filterCat.catType === cat.catType && !(filterCat.subList.find((subOcc) => subOcc.name === cat.occupation))){
              filterCat.subList = [...filterCat.subList, { name: cat.occupation, value: false }]
            }
            return filterCat
          })
        // }
      }

      return {
        ...state,
        allJobCategories: _allJobCategories,
        allJobs: allJobsList,
        idList: idFilterList,
        loading: allJobsList.length > 0 ? false : state.loading,
        occupationListFilter: _occupationListFilter
      };

    case FETCH_ALL_JOBS_COMPLETE:
      return{
        ...state,
        fetchingJobs: action.data
      }
    case UPDATE_LOAD_MORE_COUNT:
      if (action.status){
        const oldCount = action.jobCount || []
        let newJobs = state.allJobs || []
        const diff = newJobs.length - oldCount.length
        return {
          ...state,
          loadMoreStatus: {
            snackbar: action.status,
            snackbarText: action.text ? action.text : "Loaded " + diff + " New Jobs.  "
          }
        };
      }
      else{
        return {
          ...state,
          loadMoreStatus: {
            snackbar: false,
            snackbarText: false
          }
        };
      }


    case FETCH_QUALIFICATIONS:
      const { jobs = [], organisation, userQualifications=[]} = action;
      let categories = _.cloneDeep(state.allJobCategories) || [];
      let catCounts = {}
      const newQualLevelSelect = _.cloneDeep(state.qualLevelSelect || [])

      const qualMap = {"qualtest" : "SLC", "southlanarkshirecollege": "SLC"};
      const qualOrgMap = qualMap[organisation];

      var ja = jobs.map((item) => {
        var found = categories.find((cat) => {
          return cat.qualification_name.includes(item.id);
        });
        if(found){
          if(!catCounts[found.occupation]){
            catCounts[found.occupation] = 0
          }
          catCounts[found.occupation] += 1
        }
        return {
          ...item,
          ...found,
          jobId: item.qual_id,
          isQual: true,
          itemType: "qualification",
          qual_link: item.qual_link && item.qual_link.length > 5 ? item.qual_link : "",
          qual_glh_max: (typeof item.qual_glh_max === 'string' || item.qual_glh_max instanceof String) ? Math.floor(item.qual_glh_max) : item.qual_glh_max,
          qual_glh_max_number: item.qual_glh_max ? Number(item.qual_glh_max) : NaN,
          qual_sector: item.qual_sector ? item.qual_sector : "Unknown Sector",
          qual_level: item.qual_level ? item.qual_level : "Unknown Level",
          qual_credit_value_number: item.qual_credit_value ? Number(item.qual_credit_value) : NaN,
          qual_centre_flag : item.type_qual === "SLC" ? true : item.qual_centre_flag,
          promoted : (qualOrgMap && qualOrgMap === item.type_qual) ? true : false,
          canClaim: (item.type_qual === "SLC" && !userQualifications.includes(item.qual_name)) ? true : false
        };
      });


      var levels = newQualLevelSelect.map((item) => {return item.name}) || [];
      for(const element of ja){
        if(!levels.includes(element.qual_level)){
          newQualLevelSelect.push({name:element.qual_level, value:true})
          levels.push(element.qual_level)
        }
      }

      categories = categories.map((item) => {
        return{...item, qualCount: catCounts[item.occupation] ? catCounts[item.occupation] : 0}
      })
      return {
        ...state,
        loadingQualifications: action.loading,
        qualifications: ja,
        levelFilters: levels,
        qualLevelSelect: newQualLevelSelect,
        allJobCategories: categories
      };
    case FETCH_CERTIFICATIONS:
      const { certifications = [], organisation: certOrg, userCertifications = [] } = action;

      return {
        ...state,
        loadingQualifications: action.loading,
        certifications: certifications
      };
    case ADD_FILTER:
      return {
        ...state
      }
    case SET_SELECTED_JOB:
      return { ...state, selectedJobId: action.jobId };
    case SET_FAVOURITE_JOB: {
      const { favourited, job } = action.payload;
      if (favourited) {
        return {
          ...state,
          favourited: [] // Need a flag to sort
            .concat(state.favourited)
            .concat(job)
            .sort((a, b) => b.savedTimestamp - a.savedTimestamp),
        };
      } else {
        return {
          ...state,
          favourited: [] // Need a flag to sort
            .concat(state.favourited)
            .filter((favouritedJob) => favouritedJob.jobId !== job.jobId)
            .sort((a, b) => b.savedTimestamp - a.savedTimestamp),
        };
      }
    }
    case MARK_ITEM_READ: {
      const itemSort = action.itemSort;
      if (itemSort.includes("invited") || itemSort.includes("saved")) {
        const favourited = state.favourited.map((item) => {
          if (itemSort === item.itemSort) {
            return { ...item, read: true };
          }
          return item;
        });
        return {
          ...state,
          favourited: favourited,
        };
      } else {
        const appliedJobs = state.appliedJobs.map((item) => {
          if (itemSort === item.itemSort) {
            return { ...item, read: true };
          }
          return item;
        });
        return {
          ...state,
          appliedJobs: appliedJobs,
        };
      }
    }

    case APPLY_FOR_A_JOB: {


      let found = false;
      _.each(state.appliedJobs, (applied) => {
        if (applied.jobId === action.job.jobId){
          found = true;
        }
      });
      if (!found){

        let appliedJobs = [] // Need a flag to sort
        .concat(state.appliedJobs, action.job)

        if (!action.updatePosition){
          appliedJobs = appliedJobs.sort((a, b) => b.savedTimestamp - a.savedTimestamp);
        }
        
        return {
          ...state,
          appliedJobs: appliedJobs
        };
      } else {
        return {
          ...state
        }
      }
    }
    case APPLY_FOR_A_JOB_UPDATE: {
      let appliedJobs = _.map(state.appliedJobs, (_job) => {
        if (_job.jobId === action.job.jobId){
          if (action.deleteJob){
            return false
          }
          else{
            return action.job;
          }
        } else {
          return _job;
        }
      }).filter(Boolean);

      return {
        ...state,
        appliedJobs: appliedJobs.sort((a, b) => b.savedTimestamp - a.savedTimestamp),
      };
    }
    case FETCH_CENTRES: {
      if (action.jobs) {
        return {
          ...state,
          centres: action.jobs,
          centreLoading: action.loading,
        };
      }

      return {
        ...state,
        centreLoading: action.loading,
      };
    }
    case SET_ACTIVE_RESOURCE: {
      return {
        ...state,
        activeResource: action.resource
      }
    }
    case SET_RESOURCES: {
      let occ = {};
      _.each(action.data, (index, key) => {
        if (index){
          const cat = action.categoryKey[index.occupation]
          occ[index.occupation] = Array.isArray(index.video_suggestions) ? index.video_suggestions.map((item) => {return {...item,category: cat}}) : [];
        }
      });

      let occFlat = [];
      _.each(occ, (index, key) => {
          index = _.map(index, (ii) => {
            ii.occupation = key;
            return ii;
          })
          occFlat = [...index, ...occFlat];
      });
      let allResourcesFlat = [...occFlat];
      let allResources = {...occ};

      occFlat = occFlat.sort((a, b) => action.orderDict.indexOf(a.occupation) - action.orderDict.indexOf(b.occupation));
      allResourcesFlat = allResourcesFlat.sort((a, b) => action.orderDict.indexOf(a.occupation) - action.orderDict.indexOf(b.occupation));
      return {
        ...state,
        resourcesPerOccupation: occ,
        resourcesPerOccupationFlat: occFlat,
        allResourcesPerOccupation: allResources,
        allResourcesPerOccupationFlat: allResourcesFlat
      }
    }

    case SET_ONLINE_COURSES: {
      let occ = {};
      _.each(action.data, (index, key) => {
        if (index){
          const cat = action.categoryKey[index.occupation]
          occ[index.occupation] = index.course_list ? index.course_list.map((item) => {return {...item,category: cat}}) : [] 
        }
      });


      let occFlat = [];
      _.each(occ, (index, key) => {
          index = _.map(index, (ii) => {
            ii.occupation = key;
            ii.tier_one_category = index.tier_one_category;

            return ii;
          })
          occFlat = [...index, ...occFlat];
      });

      let allCoursesFlat = [...occFlat];
      let allCourses = {...occ};

      occFlat = occFlat.sort((a, b) => action.orderDict.indexOf(a.occupation) - action.orderDict.indexOf(b.occupation));
      allCoursesFlat = allCoursesFlat.sort((a, b) => action.orderDict.indexOf(a.occupation) - action.orderDict.indexOf(b.occupation));

      return {
        ...state,
        coursesPerOccupation: occ,
        coursesPerOccupationFlat: occFlat,
        allCoursesPerOccupation: allCourses,
        allCoursesPerOccupationFlat: allCoursesFlat
      }
    }
    case FETCH_JOBITEMS: {
      const { saved, invited, applied, projects } = action.jobs;
      let _invited = invited.map((item) => {
        item.isInvited = true
        return item
      })
      let favourited = saved.concat(_invited)
      return {
        ...state,
        projects: projects, //all prov projects
        appliedJobs: applied.sort(
          (a, b) => b.savedTimestamp - a.savedTimestamp
        ),
        favourited: favourited.sort(
          (a, b) => b.savedTimestamp - a.savedTimestamp
        ),
      };
    }

    case TOGGLE_PROJECTS: {
      return {
        ...state,
        projectCardActive: action.value
      };
    }

    case LEVEL_FILTER: {
      // console.log("LEVEL_FILTER")
      var levelFilters = state.levelFilters;
      var qualifications = state.qualifications;

      levelFilters = levelFilters.filter((item) => item !== action.level);

      qualifications = qualifications.filter(({ qual_level }) =>
        qual_level ? levelFilters.includes(qual_level) : true
      );

      return {
        ...state,
        qualifications,
        levelFilters,
      };
    }
    case UPDATE_OCCUPATION_SKILL: {
      

      _.each(state.recommendedJobs, (job) => {
        if (job.occupation === action.job.occupation){
          job.similar_skills = action.job.similar_skills;
          job.missing_skills = action.job.missing_skills;
        }
      })

      _.each(state.qualifications, (job) => {
        if (job.occupation === action.job.occupation){
          job.similar_skills = action.job.similar_skills;
          job.missing_skills = action.job.missing_skills;
        }
      });

      _.each(state.favourited, (job) => {
        if (job.occupation === action.job.occupation){
          job.similar_skills = action.job.similar_skills;
          job.missing_skills = action.job.missing_skills;
        }
      })

      _.each(state.appliedJobs, (job) => {
        if (job.occupation === action.job.occupation){
          job.similar_skills = action.job.similar_skills;
          job.missing_skills = action.job.missing_skills;
        }
      })

      _.each(state.jobsNearMe, (job) => {
        if (job.occupation === action.job.occupation){
          job.similar_skills = action.job.similar_skills;
          job.missing_skills = action.job.missing_skills;
        }
      })

      // state.allJobCategories[indexFound].missing_skills = action.job.missing_skills;

      return {
        ...state
      }
    }

    case UPDATE_FULL_DESCRIPTION: {
      let desc = action.description;
      let id = action.id;
      let newAllJobs =  state.allJobs
      let newRecommendedJobs = state.recommendedJobs
      return {
        ...state,
        recommendedJobs: newRecommendedJobs.map((item) => {
          if(item.jobId === id){
            return {...item, jobDescriptionFull: desc}
          }
          else{
            return item
          }
        }),
        allJobs: newAllJobs.map((item) => {
          if(item.jobId === id){
            return {...item, jobDescriptionFull: desc}
          }
          else{
            return item
          }
        }),
      }
    }
    case OPTIONAL_SKILL_CHECK: {
      let values = action.values;
      
      return {
        ...state,
        optional_skill_check: values
      }
    }

    case LOADED_CONTENT_DASHBOARD: {

      return {
        ...state,
        loadedContentDashboard: true
      }
    }
    case BLACKLIST_OCC:
      const _occupation = action.occupation
      const _isRemove = action.isRemove
      let newOccupationBlacklist = state.occupationBlacklist;
      let allJobCategories = state.allJobCategories;

      if (!newOccupationBlacklist){
        newOccupationBlacklist = []
      }
      if(_isRemove){
        newOccupationBlacklist = newOccupationBlacklist.filter((item) => item != _occupation)
      }
      else{
        newOccupationBlacklist.push(_occupation)
        allJobCategories = allJobCategories.filter((item) => !(item.catType === "searched" && item.parent_occupation === _occupation))
      }
      return {
        ...state,
        occupationBlacklist: newOccupationBlacklist,
        allJobCategories: allJobCategories
      };
    case SET_BLACKLIST:
      const newBlackList = action.newBlackList || []
      return {
        ...state,
        occupationBlacklist: newBlackList ? newBlackList : []
      };
    case JOBS_FILTER: {
      const { 
        useRecommended,
        occupationCategoryFilterChange,
        occupation = "", 
        isRemove = false, 
        userOccs, 
        occupationFilterChange= false, 
        occupationFilterReset=false 
      } = action;

      //this is category
      let occupationListFilter = action.occupationListFilter ? action.occupationListFilter : state.occupationListFilter   
      
      let sortBy = action.sortBy ? action.sortBy : state.sortBy 
      
      let distanceSelect = action.distanceSelect ? action.distanceSelect : state.distanceSelect
      let contractFilters = action.contractFilters ? action.contractFilters : state.contractFilters
      let datePosted = action.datePosted ? action.datePosted : state.datePosted
      let stringSearch = action.stringSearch !== undefined ? action.stringSearch.toLowerCase() : state.stringSearch.toLowerCase()
      let qualLevelSelect = action.qualLevelSelect ? action.qualLevelSelect : state.qualLevelSelect
      let salarySelect = action.salary ? action.salary : state.salary
      let trainingTypeFilter = action.trainingTypeFilter || state.trainingTypeFilter || [
        { name: "Qualifications", value: true },
        { name: "Certifications", value: true }
      ];

      let jobCategories = state.allJobCategories;
      let occupationBlacklist = state.occupationBlacklist || [];
      let allJobs = state.allJobs || [];
      let projects = state.projects || [];
      allJobs = [...projects, ...allJobs]
      let recommendedJobs = useRecommended ? state.recommendedJobs || [] : allJobs
      let appliedJobs = useRecommended ? state.appliedJobsFiltered || [] : state.appliedJobs || [] 
      let favourited = useRecommended ? state.favouritedFiltered || [] : state.favourited || []
      let qualifications = state.qualifications || [];
      let certifications = state.certifications || [];
      let training = useRecommended ? state.training || [] : [...certifications, ...qualifications];
      let { occupationFilter = [], occupationFilterWithAlts = {low: [],alt: [],newAlt: [],meta: []}, allResourcesPerOccupationFlat = [], allCoursesPerOccupationFlat = [], projectCardActive} = state;

      // console.log(occupation)
      let newOccupationFilter = [...occupationFilter];
      if(occupationFilterChange){
        if(occupationFilterReset){
          newOccupationFilter = []
          occupationFilterWithAlts = {
            low: [],
            alt: [],
            newAlt: [],
            meta: []
          }
          occupationListFilter = occupationListFilter.map((item) => {
            return {
              ...item, 
              subList: item.subList ? item.subList.map((_item) => {return {..._item, value:false}}) : false
            }
          })
        }
        if (occupation) {
          if (!isRemove && !occupationBlacklist.includes(occupation)) {
            if(Array.isArray(occupation)){
              newOccupationFilter = [ ...newOccupationFilter, ...occupation];
            }
            else{
              newOccupationFilter.push(occupation);
            } 
            occupationListFilter = occupationListFilter.map((item) => {
              return {...item, subList: item.subList ? item.subList.map((_item) => {
                return _item.name === occupation ? {..._item, value:true} : _item
              }) : false}
            })
          } else {
            newOccupationFilter = newOccupationFilter.filter(
              (item) => item !== occupation
            );
            occupationListFilter = occupationListFilter.map((item) => {
              return {...item, subList: item.subList ? item.subList.map((_item) => {
                return _item.name === occupation ? {..._item, value:false} : _item
              }): false}
            })
          }
          newOccupationFilter = [...new Set(newOccupationFilter)];
          if(userOccs){
            let newAlts = { low: [], alt: [], newAlt: [], meta: [] };
            for (const occ of newOccupationFilter) {
              newAlts.low.push(occ)
              for (const jobCat of jobCategories) {
                if(jobCat.occupation === occ.toLowerCase()){
                  if(jobCat.alt_labels){
                    newAlts.alt = [...newAlts.alt, ...jobCat.alt_labels]
                  }
                  if(jobCat.new_alt_labels){
                    newAlts.newAlt = [...newAlts.newAlt, ...jobCat.new_alt_labels]
                  }
                  if(jobCat.meta_labels){
                    newAlts.meta = [...newAlts.meta, ...jobCat.meta_labels]
                  }
                }
              }              
            }
            occupationFilterWithAlts = newAlts;
          }
        }
        //if we have occ filter try use relevance, else skills
        if(newOccupationFilter.length){
          sortBy = sortBy.map((item) => item.name === "Relevance" ? {...item, value:true} : {...item, value:false})
        }
        else{
          sortBy = sortBy.map((item) => item.name === "Skills" ? {...item, value:true} : {...item, value:false})
        }       
      }

      let sortByItem = sortBy.find((item) => item.value)
      let occupationCategoryFilterList = occupationListFilter ? occupationListFilter.filter((item) => item.value).map((item) => item.name) : []

      if (occupationCategoryFilterList.includes("Previous") || occupationCategoryFilterList.includes("Preferred")){
        occupationCategoryFilterList.push("Previous & Preferred")
      }
      jobCategories = jobCategories.filter((item) => occupationCategoryFilterList.includes(item.catTitle) && !occupationBlacklist.includes(item.occupation));
      
      //For changes in occ cat && for sorting quals
      if(occupationCategoryFilterList && (occupationCategoryFilterChange || occupationFilterChange)){

        if(newOccupationFilter.length){
          allResourcesPerOccupationFlat = allResourcesPerOccupationFlat.filter((item) =>
            newOccupationFilter.includes(item.occupation) && !occupationBlacklist.includes(item.occupation)
          );
          allCoursesPerOccupationFlat = allCoursesPerOccupationFlat.filter((item) => 
            newOccupationFilter.includes(item.occupation) && !occupationBlacklist.includes(item.occupation)
          );
        }
        else{
          allResourcesPerOccupationFlat = allResourcesPerOccupationFlat.filter((item) =>
            occupationCategoryFilterList.includes(item.category) && !occupationBlacklist.includes(item.occupation)
          )
          allCoursesPerOccupationFlat = allCoursesPerOccupationFlat.filter((item) => 
            occupationCategoryFilterList.includes(item.category) && !occupationBlacklist.includes(item.occupation)
          );
        }
      }

      const occupationFilterWithProjects = projectCardActive ? [...newOccupationFilter, "project"] : newOccupationFilter
      //Filtering from all jobs
      if(!useRecommended){
        const currentDistance = distanceSelect.find((item) => item.value)
        const maxDistance = currentDistance ? parseInt(currentDistance.name.replace(/[^0-9]/g, "")) : false
        const contractList = contractFilters ? contractFilters.filter((item) => item.value).map((item) => item.name) : false
        const activeDatePosted  = datePosted ? datePosted.find((item) => item.value) : false
        const maxDate = activeDatePosted && activeDatePosted.filterValue > 0 ? moment().subtract(activeDatePosted.filterValue, "days").startOf("day").format("x") : false
        const salary = salarySelect.find((item) => item.value);
        recommendedJobs = recommendedJobs.filter((job) => {
          
          if(job.catTitle && occupationCategoryFilterList && !occupationCategoryFilterList.includes(job.catTitle)){
            return false
          }
          if(occupationFilterWithProjects.length && !(occupationFilterWithProjects.includes(job.occupation) || occupationFilterWithProjects.includes(job.matched_occupation))){
            return false
          }
          if(occupationBlacklist.includes(job.occupation)){
            return false
          }
          if(maxDistance && !(job.distance_in_miles < maxDistance)){
            return false
          }
          if(contractList){
            if (job.is_apprenticeship && !contractList.includes("Apprenticeships")){
              return false
            }
            else if(job.original_location === "remote" && !contractList.includes("Remote Jobs")){
              return false
            }
            else if (job.job_contract && job.job_contract !=="unknown" && !contractList.includes(job.job_contract + " Jobs")){
              return false
            }
          }
          if(maxDate && job.postedDate && !(job.postedDate > maxDate)){
            return false
          }
          if(stringSearch && !((job.jobTitle && job.jobTitle.toLowerCase().includes(stringSearch)) || (job.qual_name && job.qual_name.toLowerCase().includes(stringSearch)) || (job.original_location && job.original_location.toLowerCase().includes(stringSearch)) || (job.provider && job.provider.toLowerCase().includes(stringSearch)) || (job.employerName && job.employerName.toLowerCase().includes(stringSearch)))){
            return false
          }
          if(salary && salary.filterValue && (job.annual_salary_max || job.annual_salary_min)){
            if(job.annual_salary_min){
              if(job.salary_type && !["unknown", "yearly", "annually", "annual"].includes(job.salary_type)){
                if(["hourly", "daily"].includes(job.salary_type)){
                  if((job.annual_salary_min * 36.4 * 52) < salary.filterValue){
                    return false
                  }
                }
              }
              else if(job.annual_salary_min < salary.filterValue){
                return false
              }
            }
            else{
              if(job.salary_type && !["unknown", "yearly", "annually", "annual"].includes(job.salary_type)){
                if(["hourly", "daily"].includes(job.salary_type)){
                  if((job.annual_salary_max * 36.4 * 52) < salary.filterValue){
                    return false
                  }
                }
              }
              else if(job.annual_salary_max < salary.filterValue){
                return false
              }
            }
          }


          return job
        })

        appliedJobs = appliedJobs.filter((job) => {
          if(stringSearch && !((job.jobTitle && job.jobTitle.toLowerCase().includes(stringSearch)) || (job.qual_name && job.qual_name.toLowerCase().includes(stringSearch)) || (job.original_location && job.original_location.toLowerCase().includes(stringSearch)))){
            return false
          }
          return job
        })

        favourited = favourited.filter((job) => {
          if(stringSearch && !((job.jobTitle && job.jobTitle.toLowerCase().includes(stringSearch)) || (job.qual_name && job.qual_name.toLowerCase().includes(stringSearch)) || (job.original_location && job.original_location.toLowerCase().includes(stringSearch)))){
            return false
          }
          return job
        })

        const qualLevelList = qualLevelSelect ? qualLevelSelect.filter((item) => item.value).map((item) => item.name) : false
        //filtered job cats from newOccupationFilter
        let filteredJobCategories = newOccupationFilter.length ? jobCategories.filter((item) => newOccupationFilter.includes(item.occupation)) : jobCategories;

        //qual filtering and level populating
        var qnames = [];
          filteredJobCategories.forEach((item) => {
            qnames = [...qnames, ...item.qualification_name];
          });
        qnames = [...new Set(qnames)];
        qualifications = qualifications.filter(({ id, qual_name, qual_level }) => {
          if(!qnames.includes(id)){
            return false
          }
          if(stringSearch && !((qual_name && qual_name.toLowerCase().includes(stringSearch)))){
            return false
          }
          if(qualLevelList && !(qual_level ? qualLevelList.includes(qual_level) : true)){
            return false
          }
          return true
        });

        const occupationFilterWithProjectsTraining = projectCardActive ? [...newOccupationFilter, "project"] : newOccupationFilter;
        const showQualifications = trainingTypeFilter?.some((item) => item.name === "Qualifications" && item.value);
        const showCertifications = trainingTypeFilter?.some((item) => item.name === "Certifications" && item.value);
        training = training.filter((item) => {
          // Filter by training type
          if(item.isCertification && !showCertifications){
            return false
          }
          if(!item.isCertification && !showQualifications){
            return false
          }
          if(item.isCertification){
            return true
          }
          if(occupationFilterWithProjectsTraining.length && !(occupationFilterWithProjectsTraining.includes(item.occupation) || occupationFilterWithProjectsTraining.includes(item.matched_occupation))){
            return false
          }
          if(occupationBlacklist.includes(item.occupation)){
            return false
          }
          if(stringSearch && !((item.qual_name && item.qual_name.toLowerCase().includes(stringSearch)) || (item.title && item.title.toLowerCase().includes(stringSearch)))){
            return false
          }
          return true
        });
      }
      if(sortByItem){
        if(sortByItem.name === "Relevance"){
          function ranker(jobsList) {
            return jobsList.map((item) => {
              const lowerJob = item.qual_name ? item.qual_name.toLowerCase() : item.title ? item.title.toLowerCase() : item.jobTitle.toLowerCase()
              let rank = 6;
              if(occupationFilterWithAlts.low.includes(lowerJob)){
                rank = 0;
              }
              else if(occupationFilterWithAlts.low.find((filterItem) => lowerJob.includes(filterItem))){
                rank = 1;
              }
              else if(occupationFilterWithAlts.alt.includes(lowerJob)){
                rank = 2;
              }
              else if(occupationFilterWithAlts.alt.find((filterItem) => lowerJob.includes(filterItem))){
                rank = 3;
              }
              else if(occupationFilterWithAlts.newAlt.find((filterItem) => lowerJob.includes(filterItem))){
                rank = 4;
              }
              else if(occupationFilterWithAlts.meta.find((filterItem) => lowerJob.includes(filterItem))){
                rank = 5;
              }
              return {...item, rank: rank}
            })
          }
          recommendedJobs = _.orderBy(ranker(recommendedJobs), ["rank"], ["asc"]);
          appliedJobs = _.orderBy(ranker(appliedJobs), ["rank"], ["asc"]);
          favourited = _.orderBy(ranker(favourited), ["rank"], ["asc"]);
          training = _.orderBy(training, ["score_bp"], ["desc"])
        }
        else if(sortByItem.name === "Skills"){
          recommendedJobs = _.orderBy(recommendedJobs, "score_bp", "desc")
          appliedJobs = _.orderBy(appliedJobs, "score_bp", "desc")
          favourited = _.orderBy(favourited, "score_bp", "desc")
          training = _.orderBy(training, "score_bp", "desc")
        }
        else if(sortByItem.name === "Style"){
          recommendedJobs = _.orderBy(recommendedJobs, "score_styles", "desc")
          appliedJobs = _.orderBy(appliedJobs, "score_styles", "desc")
          favourited = _.orderBy(favourited, "score_styles", "desc")
          training = _.orderBy(training, "score_styles", "desc")
        }
        else if(sortByItem.name === "Interests"){
          recommendedJobs = _.orderBy(recommendedJobs, "score_interest", "desc")
          appliedJobs = _.orderBy(appliedJobs, "score_interest", "desc")
          favourited = _.orderBy(favourited, "score_interest", "desc")
          training = _.orderBy(training, "score_interest", "desc")
        }
      }

      recommendedJobs = _.orderBy(recommendedJobs, ["project_flag", "vacancy_flag"], ["asc"]);
      // Sort training: promoted quals first, then by score. Certs (no promoted) go after promoted quals
      training = _.orderBy(training, ["promoted", "score_bp"], ["desc", "desc"])

      if(occupationCategoryFilterChange || occupationFilterChange){
        return {
            ...state,
          resourcesPerOccupationFlat: allResourcesPerOccupationFlat,
          coursesPerOccupationFlat: allCoursesPerOccupationFlat,
          occupationListFilter,
          occupationFilter: newOccupationFilter,
          occupationFilterWithAlts: occupationFilterWithAlts,
          allJobCategories: jobCategories,
          recommendedJobs,
          training,
          sortBy: sortBy,
          distanceSelect: distanceSelect,
          contractFilters: contractFilters,
          datePosted: datePosted,
          stringSearch: stringSearch,
          appliedJobsFiltered: appliedJobs,
          favouritedFiltered: favourited,
          qualLevelSelect,
          salary: salarySelect
        };        
      }
      else{
        return {
          ...state,
          recommendedJobs,
          sortBy: sortBy,
          distanceSelect: distanceSelect,
          contractFilters: contractFilters,
          datePosted: datePosted,
          stringSearch: stringSearch,
          appliedJobsFiltered: appliedJobs,
          favouritedFiltered: favourited,
          training
        };
      }
    }
    case OCC_FILTER: {
      // console.log("OCC_FILTER")
      var jobCategories = state.allJobCategories;
      var recommendedJobs = state.allJobs || [];
      var qualifications = state.qualifications || [];

      var filters = action.filter;
      var x = action.filter.map((item) => {
        if (item.value) {
          return item.name;
        } else {
          return null;
        }
      });

      let previousAndPreferred = false;
      _.each(x, (i) => {
        if (i === "Previous" && !previousAndPreferred){
          x.push("Previous & Preferred");
          previousAndPreferred = true;
        }
        if (i === "Preferred" && !previousAndPreferred){
          x.push("Previous & Preferred");
          previousAndPreferred = true;
        }
      });


      if (!x.find((element) => element !== null)) {
        x = filters.map((item) => {
          return item.name;
        });

        filters = action.filter.map((item) => {
          item.value = true;
          return item;
        });
      }

      jobCategories = jobCategories.filter((item) => x.includes(item.catTitle));
      recommendedJobs = recommendedJobs.filter((item) =>
        x.includes(item.catTitle)
      );

      var qnames = [];
      jobCategories.forEach((item) => {
        qnames = [...qnames, ...item.qualification_name];
      });

      qualifications = qualifications.filter(({ id }) => qnames.includes(id));

      var levelObject = {};
      qualifications.forEach((element) => {
        levelObject[element.qual_level] = true;
      });
      var levels = Object.keys(levelObject);

      return {
        ...state,
        occupationListFilter: filters,
        occupationFilter: [],
        jobCategories,
        recommendedJobs,
        qualifications,
        levelFilters: levels,
      };
    }

    default:
      return {
        ...state,
        occupationListFilter: state.occupationListFilter ? state.occupationListFilter : [
          { name: "Preferred", catType: "desired", value: true, subList: [] },
          { name: "Previous", catType: "past", value: true, subList: [] },
          { name: "Skills", catType: "skills_backpack", value: true, subList: [] },
          { name: "Styles", catType: "styles", value: true, subList: [] },
          { name: "Interest", catType: "interest", value: true, subList: [] },
          { name: "Searched", catType: "searched", value: true, subList: [] },
        ],
        sortBy: [
          { name: "Relevance", value: true},
          { name: "Skills", value: false },
          { name: "Style", value: false },
          { name: "Interests", value: false }
        ],
        distanceSelect: [
          { name: "Up to 10 miles", value: false },
          { name: "Up to 30 miles", value: false },
          { name: "Up to 50 miles", value: false },
          { name: "No limit", value: true }
        ],
        contractFilters: [
          { name: "Full Time Jobs", value: true},
          { name: "Part Time Jobs",value: true},
          { name: "Apprenticeships", value: true },
          // {name: "Remote Jobs", value: true}
        ],
        salary : [
          { name: "All Salaries", value: true, filterValue: 0},
          { name: "£20k +", value: false, filterValue: 20000},
          { name: "£30k +", value: false, filterValue: 30000},
          { name: "£40k +", value: false, filterValue: 40000},
          { name: "£50k +", value: false, filterValue: 50000},
          { name: "£60k +", value: false, filterValue: 60000},
          { name: "£70k +", value: false, filterValue: 70000},
        ],
        datePosted: [
          { name: "Last 24 hours", value: false, filterValue:1 },
          { name: "Last 7 days", value: false, filterValue:7 },
          { name: "Last 14 days", value: false, filterValue:14 },
          { name: "All time", value: true, filterValue:0 }
        ],
        stringSearch: "",
        qualLevelSelect: state.qualLevelSelect ? state.qualLevelSelect : [
          { name: "Level 1/2", value: true},
          { name: "Level 1", value: true},
          { name: "Level 2", value: true},
          { name: "Level 3", value: true},
          { name: "Level 4", value: true},
          { name: "Level 5", value: true},
        ],
        trainingTypeFilter: state.trainingTypeFilter ? state.trainingTypeFilter : [
          { name: "Qualifications", value: true },
          { name: "Certifications", value: true }
        ],
      };
  }
};
